module.exports = __webpack_public_path__ + "static/img/about_fw_2.79cab84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_fw_2.png
// module id = vC/U
// module chunks = 1